import React, { useContext, useState, useEffect } from 'react';
import { StateStore } from '../store';
import './PrayersContainer.scss';
import PrayerModal from './PrayerModal';
import { editPrayerStatus, setTimings } from '../Actions/UserActions';
import { names } from '../Data';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle, faTimes } from '@fortawesome/free-solid-svg-icons';
import { timeGreater, timeConvert } from '../Functions';

export default function PrayersContainer({ currTime }) {
  const [modalState, setModalState] = useState(false);
  const [prayerState, setPrayerState] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const { state: { preferences, timings, stati, user }, dispatch } = useContext(StateStore);
  const { location, calcMethod, timeFormat } = preferences || {};
  useEffect(() => {
    if (!preferences) {
      setLoading(true);
      console.log('llll')
      return;
    }
    const fetchData = async () => {
      if (calcMethod !== timings?.calcMethod || !timings || timings?.date !== new Date().toDateString() || timings?.location?.city !== location.city || timings?.location?.country !== location.country) {
        setLoading(true);
        const { city, country } = location;

        let res;
        try {
          res = await fetch(`https://api.aladhan.com/v1/timingsByCity?city=${city}&country=${country}&method=${calcMethod}&school=1`);
          if (!res.ok) throw new Error(res);
        } catch (err) {
          setLoading(false);
          setError("Unable to update Prayer timings right now");
          return;
        }

        let json = await res.json();

        const newTimings = json.data.timings;
        newTimings.location = { ...location };
        newTimings.date = new Date().toDateString();
        newTimings.calcMethod = calcMethod;

        setTimings(dispatch, newTimings);
        setLoading(false);
      } else {
        setLoading(false);
      }
    }
    fetchData();
  }, [calcMethod, dispatch, location, timings, preferences]);

  const save = (formData, char) => {
    editPrayerStatus(user, stati[stati.length - 1].uid, formData.name, char);
  }

  return (
    <>
      {(loading || (!timings) || (!stati)) ?
        <div className="prayers-container">
          {names.map((name, index) => (<Prayer
            status={"n"}
            loading={true}
            key={name}
          ></Prayer>))}
        </div> :
        <div className="prayers-container">
          {names.map((name, index) => (<Prayer
            key={name}
            name={name}
            time={timeFormat === "12" ? timeConvert(timings[name]) : timings[name]}
            timePassed={timeGreater(currTime, timings[name])}
            status={stati[stati.length - 1][name]}
            onClick={() => { setPrayerState({ name, status: stati[stati.length - 1][name] }); setModalState(true); }}
          ></Prayer>))}
        </div>
      }
      {
        !error ? null :
          (<div className="card error">
            <FontAwesomeIcon className="icon" icon={faExclamationTriangle}></FontAwesomeIcon>
            <span>{error}</span>
            <div className="delete" onClick={() => setError(null)}><FontAwesomeIcon icon={faTimes}></FontAwesomeIcon></div>
          </div>)
      }
      {
        !modalState ? null :
          <PrayerModal theme={preferences.theme} save={save} prayerState={prayerState} modalIsOpen={modalState} toggle={setModalState}></PrayerModal>
      }
    </>
  )
}

function Prayer(props) {
  let messages = {
    o: name => (`You prayed ${props.name} Prayer on time`),
    m: name => (`You missed ${props.name} Prayer`),
    n: name => (
      props.timePassed ?
        `${props.time} Onwards ${props.name} Prayer` :
        `${props.time} Onwards ${props.name} Prayer`
    ),
    d: name => (`You prayed ${props.name} Prayer at a delayed time`),
    ex: name => (`You were exempted from offering ${props.name} Prayer`)
  }
  return (
    <button onClick={(props.status === 'n' && !props.timePassed) ? null : props.onClick} className={"card prayer-card " + props.status + ((props.status === 'n' && !props.timePassed) ? " future" : "")}>
      {props.loading ? <span className="filler"></span> : messages[props.status] ? messages[props.status](props) : "Oops, Something went horribly wrong."}
    </button>
  )
}